import { render } from "./AdministerCollectionItem.vue?vue&type=template&id=676275fa"
import script from "./AdministerCollectionItem.vue?vue&type=script&lang=js"
export * from "./AdministerCollectionItem.vue?vue&type=script&lang=js"

import "./AdministerCollectionItem.vue?vue&type=style&index=0&id=676275fa&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__